import type { IconData } from '@stacksjs/iconify-core'

export const mm1x1: IconData = {
  "body": "<path fill=\"#fecb00\" d=\"M0 0h512v512H0z\"/><path fill=\"#34b233\" d=\"M0 170.7h512V512H0z\"/><path fill=\"#ea2839\" d=\"M0 341.3h512V512H0z\"/><path id=\"SVGvLw7LcjF\" fill=\"#fff\" stroke-width=\"188.7\" d=\"M312.6 274H199.4L256 85.3Z\"/><use width=\"100%\" height=\"100%\" href=\"#SVGvLw7LcjF\" transform=\"rotate(-144 256 274)\"/><use width=\"100%\" height=\"100%\" href=\"#SVGvLw7LcjF\" transform=\"rotate(-72 256 274)\"/><use width=\"100%\" height=\"100%\" href=\"#SVGvLw7LcjF\" transform=\"rotate(72 256 274)\"/><use width=\"100%\" height=\"100%\" href=\"#SVGvLw7LcjF\" transform=\"rotate(144 256 274)\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default mm1x1
